import { Swiper, Navigation, Keyboard, A11y, Pagination } from 'swiper';

const statsCardSections = document.querySelectorAll(".adm-section-c16-stats");

Array.prototype.forEach.call(statsCardSections,
    (statsCardSection, index) => {
        statsCardSection.classList.add(`section-${index}`);
        //#region Desktop Swiper

        var desktopSwiperC16 = new Swiper(`.section-${index} .adm-div-c16-stats-slider.swiper`, {
            modules: [Navigation, Keyboard, A11y, Pagination],
            slidesPerView: 1,
            speed: 1500,
            a11y: false,
            keyboard: {
                enabled: true
            },
            pagination: {
                el: `.section-${index} .adm-div-c16-stats-slider-controls .adm-div-c16-stats-slider-pagination`,
                type: "fraction",
                formatFractionCurrent: function (number) {
                    return number.toString().padStart(2, "0");
                },
                formatFractionTotal: function (number) {
                    return number.toString().padStart(2, "0");
                }
            },
            navigation: {
                nextEl: statsCardSection.querySelector(".adm-button-c16-stats-arrow.adm-right-arrow"),
                prevEl: statsCardSection.querySelector(".adm-button-c16-stats-arrow.adm-left-arrow")
            },
            width: 365,
            on: {
                resize: (swiper) => {
                    if (swiper.activeIndex === 0) {
                        statsCardSection.querySelector(".adm-button-c16-stats-arrow.adm-left-arrow").classList.add("swiper-button-disabled");
                    }
                }
            },
            onAny() {
                statsCardSection.querySelector(".adm-button-c16-stats-arrow.adm-right-arrow").tabIndex = -1;
                statsCardSection.querySelector(".adm-button-c16-stats-arrow.adm-left-arrow").tabIndex = -1;
            }
        });

        function slideToWhenTabbingStatsCards(s) {
            s.slides.forEach((slide, slideIndex) => {
                slide.addEventListener("focusin", () => s.slideTo(slideIndex, 300));
            });
        }

        function removeSwiperActiveClass(s) {
            s.slides[s.activeIndex].classList.remove("swiper-slide-active");
        }

        function addSwiperActiveClass(s) {
            s.slides[s.activeIndex].classList.add("swiper-slide-active");
        }
        desktopSwiperC16.on("keyPress", (s) => slideToWhenTabbingStatsCards(s));

        desktopSwiperC16.slides.forEach(slide => {
            slide.addEventListener("mouseover", () => removeSwiperActiveClass(desktopSwiperC16));
            slide.addEventListener("mouseout", () => addSwiperActiveClass(desktopSwiperC16));
        });

        //#endregion

        //#region Tablet Swiper

        var tabletSwiperC16 = new Swiper(`.section-${index} .adm-div-c16-stats-slider-tablet.swiper`, {
            modules: [Navigation, Keyboard, A11y, Pagination],
            slidesPerView: 1,
            speed: 1500,
            a11y: false,
            keyboard: {
                enabled: true
            },
            pagination: {
                el: `.section-${index} .adm-div-c16-stats-slider-controls .adm-div-c16-stats-slider-tablet-pagination`,
                type: "fraction",
                formatFractionCurrent: function (number) {
                    return number.toString().padStart(2, "0");
                },
                formatFractionTotal: function (number) {
                    return number.toString().padStart(2, "0");
                }
            },
            navigation: {
                nextEl: statsCardSection.querySelector(".adm-div-c16-stats-slider-tablet-right-arrow"),
                prevEl: statsCardSection.querySelector(".adm-div-c16-stats-slider-tablet-left-arrow")
            },
            width: 382,
            on: {
                resize: (swiper) => {
                    if (swiper.activeIndex === 0) {
                        statsCardSection.querySelector(".adm-div-c16-stats-slider-tablet-left-arrow").classList.add("swiper-button-disabled");
                    }
                }
            },
            onAny() {
                statsCardSection.querySelector(".adm-div-c16-stats-slider-tablet-right-arrow").tabIndex = -1;
                statsCardSection.querySelector(".adm-div-c16-stats-slider-tablet-left-arrow").tabIndex = -1;
            }
        });

        tabletSwiperC16.slides.forEach(slide => {
            slide.addEventListener("touchstart", () => removeSwiperActiveClass(tabletSwiperC16), { passive: true });
            slide.addEventListener("touchend", () => addSwiperActiveClass(tabletSwiperC16));
        });

        tabletSwiperC16.on("keyPress", (s) => slideToWhenTabbingStatsCards(s));

        //#endregion

        //#region Mobile Swiper

        new Swiper(`.section-${index} .adm-div-c16-stats-slider-mobile.swiper`, {
            modules: [Navigation, Keyboard, A11y, Pagination],
            slidesPerView: "auto",
            centeredSlides: true,
            spaceBetween: 16,
            speed: 1500,
            a11y: false,
            keyboard: {
                enabled: true
            },
            pagination: {
                el: `.section-${index} .adm-div-c16-stats-slider-mobile-controls .adm-div-c16-stats-slider-pagination`,
                type: "fraction",
                formatFractionCurrent: function (number) {
                    return number.toString().padStart(2, "0");
                },
                formatFractionTotal: function (number) {
                    return number.toString().padStart(2, "0");
                }
            },
            navigation: {
                nextEl: statsCardSection.querySelector(".adm-div-c16-stats-slider-right-arrow"),
                prevEl: statsCardSection.querySelector(".adm-div-c16-stats-slider-left-arrow")
            },
            on: {
                resize: (swiper) => {
                    if (swiper.activeIndex === 0) {
                        statsCardSection.querySelector(".adm-div-c16-stats-slider-tablet-left-arrow").classList.add("swiper-button-disabled");
                    }
                }
            },
            onAny() {
                statsCardSection.querySelector(".adm-div-c16-stats-slider-right-arrow").tabIndex = -1;
                statsCardSection.querySelector(".adm-div-c16-stats-slider-left-arrow").tabIndex = -1;
            }
        });

        //#endregion
    });